
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"error.dialog.message":"Please contact the application administrator.","error.dialog.title":"Failed to open the extended selection"},"de":{"error.dialog.message":"Bitte wenden Sie sich an den Anwendungsbetreuer.","error.dialog.title":"Fehler beim Öffnen der erweiterten Auswahl"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();